import { render, staticRenderFns } from "./ShiftNote.vue?vue&type=template&id=47e6a608&"
import script from "./ShiftNote.vue?vue&type=script&lang=js&"
export * from "./ShiftNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports